let isMobile = null;

window.ShopifyDeviceManager = (function() {
  const deviceCallbacks = new Set();

  function detectDevice() {
    const mobile = window.matchMedia('(max-width: 768px)').matches;
    return mobile;
  }

  function updateDeviceClass() {
    const newIsMobile = detectDevice();

    if (newIsMobile === isMobile) {
      return;
    }

    console.log('[Device] CHANGE:', {
      from: isMobile === null
        ? null
        : isMobile ? 'mobile' : 'desktop',

      to: newIsMobile
        ? 'mobile'
        : 'desktop',

      width: window.innerWidth
    });

    isMobile = newIsMobile;

    document.documentElement.classList.toggle('mobile', isMobile);

    console.log("Number of device callbacks:", deviceCallbacks.size);

    deviceCallbacks.forEach(cb => cb(isMobile));
  }

  const onDeviceChange = function(callback) {
    deviceCallbacks.add(callback);
    const current = isMobile ?? detectDevice();
    callback(current);
  };

  const mediaQuery = window.matchMedia('(max-width: 768px)');

  mediaQuery.addEventListener('change', updateDeviceClass);

  updateDeviceClass();

  return {
    onDeviceChange,
  };
})();